import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Headers, Http, Request, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Note } from './note.model';


@Injectable()
export class NoteService {

  constructor(private http: HttpClient) { }

  searchNotes(searchString: string): Observable<Note[]> {
    // see https://github.com/surfer77/mongoose-string-query for full API!
    return this.http.get<Note[]>('/api/notes/search?' + searchString).map((notes: Note[]) => {
      return notes;
    }).catch( this.handleError );

  }

  // Defines routes for note data retrieval
  getNotes(): Observable<Note[]> {
    return this.http.get<Note[]>('/api/notes').map((notes: Note[]) => {
      return notes;
    }).catch( this.handleError );
  }

  countNotes(): Observable<number> {
    return this.http.get<number>('/api/notes/count');
  }

  addNote(note: Note): Observable<Note> {
    // console.log(note);
    return this.http.post<Note>('/api/note', note);
  }

  getNoteFromId(id: string): Observable<Note> {
    return this.http.get<Note>(`/api/note/${id}`);
  }

  getNote(note: Note): Observable<Note> {
    return this.http.get<Note>(`/api/note/${note._id}`);
  }

  editNote(note: Note): Observable<string> {
    return this.http.put(`/api/note/${note._id}`, note, { responseType: 'text' });
  }

  deleteNote(note: Note): Observable<string> {
    return this.http.delete(`/api/note/${note._id}`, { responseType: 'text' });
  }

  private handleError(error: Response) {
    return Observable.throw(error.statusText);
  }


}



// WEBPACK FOOTER //
// ./client/app/shared/notes/note.service.ts